import { IonButton, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import SettingsTableColumn from "../../../../../Settings/SettingsComponents/SettingsTable/SettingsTableColumn/SettingsTableColumn";
import Checkbox from "../Checkbox/Checkbox";
import { useL10n } from "@ews/react-localization-context";
import { Options } from "./types";
import
{
    setNotificationChannel,
    unsetNotificationChannel,
    hasNotificationChannel,
    NotificationChannel
} from "@ews/react-data";
import { Locale } from "../../../../../../setup/locale";
import { PushCategory } from "@ews/zlt-events";


const PushOption: React.FC<Options> = ({
    size,
    style,
    label = "",
    disabled = false,
    hidden = false,
    center,
    value,
    options,
    onChange,
    onSelect,
    sound,
    sizeSoundCol,
    pushCategory = PushCategory.None,
    onClickTestPush,
}) =>
{

    const { translate: t } = useL10n();

    function onChangeHandler(selectedEvent: number, checked: boolean)
    {
        value = checked ? setNotificationChannel(value, selectedEvent) : unsetNotificationChannel(value, selectedEvent);
        if (onChange) onChange(value);
    }

    if (hidden) return <></>;

    return <>
        <SettingsTableColumn size="4" center={center}>
            <IonLabel style={style}>{t(label)}</IonLabel>
        </SettingsTableColumn>
        {"push" in options && <SettingsTableColumn size={size}>
            {options.push && <Checkbox
                disabled={disabled}
                text={(options.push || "[REACT_BEGIN]") as Locale}
                checked={hasNotificationChannel(value, NotificationChannel.PUSH)}
                onChange={(checked) =>
                {
                    onChangeHandler(NotificationChannel.PUSH, checked);
                }} />}
        </SettingsTableColumn>}

        {"push_end" in options && <SettingsTableColumn size={size}>
            {options.push_end && <Checkbox
                disabled={disabled || !hasNotificationChannel(value, NotificationChannel.PUSH)}
                text={(options.push_end || "COM_FACPMANAGEMENT_END_EVENT") as Locale}
                checked={hasNotificationChannel(value, NotificationChannel.PUSH_END)}
                onChange={(checked) =>
                {
                    onChangeHandler(NotificationChannel.PUSH_END, checked);
                }} />}
        </SettingsTableColumn>}

        {"email" in options && <SettingsTableColumn size={size}>
            {options.email && <Checkbox
                disabled={disabled}
                text={(options.email || "[REACT_BEGIN]") as Locale}
                checked={hasNotificationChannel(value, NotificationChannel.EMAIL)}
                onChange={(checked) =>
                {
                    onChangeHandler(NotificationChannel.EMAIL, checked);
                }} />}
        </SettingsTableColumn>}

        {"email_end" in options && <SettingsTableColumn size={size}>
            {options.email_end && <Checkbox
                disabled={disabled || !hasNotificationChannel(value, NotificationChannel.EMAIL)}
                text={(options.email_end || "COM_FACPMANAGEMENT_END_EVENT") as Locale}
                checked={hasNotificationChannel(value, NotificationChannel.EMAIL_END)}
                onChange={(checked) =>
                {
                    onChangeHandler(NotificationChannel.EMAIL_END, checked);
                }} />}
        </SettingsTableColumn>}

        {onSelect && <SettingsTableColumn size={sizeSoundCol}>
            <IonSelect
                disabled={disabled}
                value={sound || "none"}
                onIonChange={({ detail }) => onSelect(detail.value || "")}
            >
                <IonSelectOption value={"default"}>{t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT")}</IonSelectOption>
                <IonSelectOption value={"fire1"}> {t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING")}</IonSelectOption>
                <IonSelectOption value={"fire2"}>  {t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP")}</IonSelectOption>
                <IonSelectOption value={"fire3"}>{t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS")}</IonSelectOption>
                <IonSelectOption value={"fire4"}>{t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF")}</IonSelectOption>
                <IonSelectOption value={"hinweiston"}>{t("PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ERROR")}</IonSelectOption>
                <IonSelectOption value={"none"}>{t("TD_KEIN")}</IonSelectOption>
            </IonSelect>
        </SettingsTableColumn>}

        {onClickTestPush && <SettingsTableColumn size={size}>
            <IonButton
                disabled={disabled}
                color={"success"}
                onClick={() => onClickTestPush(pushCategory)}
            >
                <span>{t("[REACT_TEST_PUSH_BUTTON]")}</span>
            </IonButton>
        </SettingsTableColumn>}

    </>;
};

export default PushOption;
